var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNutritionDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 553.061,
    height: 421.665,
    viewBox: "0 0 553.061 421.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146",
    transform: "translate(276.43 -159.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6848",
    "data-name": "Path 6848",
    d: "M-223.944,520.012s-72.569-78.582-47.046-170.186c16.671-59.831,71.947-23.582,69-120.578S-39.117,122.173,6.855,150.313,53.8,196.433,148.727,185.258s136.239,74.106,87.056,145.754c-43.069,62.741,97.227,56.447,13.827,189.175Z",
    transform: "translate(0 60.884)",
    fill: "#deece9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6896",
    "data-name": "Path 6896",
    d: "M250.2,509.882s-42.8-45.954-7.238-95.705c31.553-44.143,68.341-41.125,95.331-23.212,11.5,7.629,44.639.94,72.848-43.977,38.469-61.255,171.818-24.1,147.5,70.138-11.766,45.606,35.809,47.264,11.568,92.852Z",
    transform: "translate(-360.164 6.637)",
    fill: "#cce4df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2812",
    "data-name": "Group 2812",
    transform: "translate(-166.773 159.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6849",
    "data-name": "Path 6849",
    d: "M611.893,448.207l-1.464-3.41-3.638-.727a.51.51,0,0,1-.237-.883l2.791-2.446-.433-3.685a.51.51,0,0,1,.767-.5l3.188,1.9,3.371-1.551a.51.51,0,0,1,.71.576l-.82,3.619,2.517,2.727a.51.51,0,0,1-.328.853l-3.695.339-1.816,3.236A.51.51,0,0,1,611.893,448.207Z",
    transform: "translate(-511.023 -393.806)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794",
    transform: "translate(272.075 1.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6850",
    "data-name": "Path 6850",
    d: "M1367.344,264.506l1.138-1.453,3.548,2.779,3-5.273,1.6.913-4.06,7.132Z",
    transform: "translate(-1367.344 -260.559)",
    fill: "#50bfa5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796",
    transform: "translate(115.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6851",
    "data-name": "Path 6851",
    d: "M711.325,262.667a9.052,9.052,0,1,1-8.1-9.917A9.051,9.051,0,0,1,711.325,262.667Z",
    transform: "translate(-693.267 -252.704)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6852",
    "data-name": "Path 6852",
    d: "M710.811,295.74a4.84,4.84,0,1,0,9.63.973Z",
    transform: "translate(-706.718 -285.746)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6853",
    "data-name": "Path 6853",
    d: "M1459.593,383.591l2.739-2.932-1.52-1.006a.722.722,0,0,1-.2-1h0a.722.722,0,0,1,1-.2l1.753,1.16,2.451-2.635-1.624-1.075a.722.722,0,0,1-.2-1h0a.722.722,0,0,1,1-.2l1.857,1.229,2.837-3.011a.723.723,0,0,1,.924-.107l.283.188a.722.722,0,0,1,.131,1.094l-2.648,2.847,2.692,1.782,2.837-3.011a.722.722,0,0,1,.924-.107l.309.2a.722.722,0,0,1,.13,1.094l-2.648,2.847,1.52,1.006a.723.723,0,0,1,.2,1h0a.722.722,0,0,1-1,.2l-1.753-1.16-2.425,2.652,1.623,1.074a.722.722,0,0,1,.2,1h0a.722.722,0,0,1-1,.2l-1.857-1.229-2.9,3.11a.722.722,0,0,1-.926.11l-.332-.22a.722.722,0,0,1-.129-1.1l2.739-2.932-2.692-1.782-2.9,3.11a.723.723,0,0,1-.927.109l-.332-.219A.722.722,0,0,1,1459.593,383.591Zm8.014-1.173,2.451-2.635L1467.366,378l-2.451,2.635Z",
    transform: "translate(-1165.946 -344.822)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2805",
    "data-name": "Group 2805",
    transform: "translate(169.419 0.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6854",
    "data-name": "Path 6854",
    d: "M1017.431,312.135a7.741,7.741,0,0,1,5.688-3.422,5.994,5.994,0,0,1,6.682,5.434c.427,3.8-2.4,8.678-10.622,13.562-9.1-2.939-12.938-7.065-13.365-10.869a5.994,5.994,0,0,1,5.311-6.781A7.743,7.743,0,0,1,1017.431,312.135Z",
    transform: "translate(-987.085 -296.342)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797",
    transform: "translate(0 18.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6855",
    "data-name": "Path 6855",
    d: "M926.464,335.973a79.876,79.876,0,0,0,9.124-.037c.917-.056,2.524.117,3.111-.708a.967.967,0,0,0-.068-1.323c-.722-.72-2.085-.336-3.009-.28-2.817.171-6.012.231-9.245.1a1.133,1.133,0,0,0-1.079,1.165,1.147,1.147,0,0,0,1.166,1.079Z",
    transform: "translate(-925.298 -333.472)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2798",
    "data-name": "Group 2798",
    transform: "translate(47.496 22.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6856",
    "data-name": "Path 6856",
    d: "M1130.947,354.169c1.349-.059,2.7-.144,4.043-.224a12.373,12.373,0,0,0,4.022-.454.973.973,0,0,0-.076-1.863,12.221,12.221,0,0,0-4.034.027c-1.348.085-2.7.165-4.042.27a1.124,1.124,0,0,0,.087,2.244Z",
    transform: "translate(-1129.82 -351.453)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2799",
    "data-name": "Group 2799",
    transform: "translate(12.516 30.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6857",
    "data-name": "Path 6857",
    d: "M981.311,394.71c1.526-2.937,3.535-3.931,5.045-5.111a.908.908,0,0,0-.752-1.626c-2.8.609-5.049,3.278-6.283,5.716a1.119,1.119,0,0,0,1.99,1.021Z",
    transform: "translate(-979.192 -387.946)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2800",
    "data-name": "Group 2800",
    transform: "translate(28.264 36.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6858",
    "data-name": "Path 6858",
    d: "M1049.324,418.837a9.933,9.933,0,0,1,.437-4.09c.268-.813,1.746-3.122.139-3.447-1.513-.306-2.175,2.191-2.471,3.247a11.734,11.734,0,0,0-.359,4.377c.152,1.436,2.393,1.362,2.254-.087Z",
    transform: "translate(-1047.005 -411.274)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2801",
    "data-name": "Group 2801",
    transform: "translate(40.904 32.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6859",
    "data-name": "Path 6859",
    d: "M1102.057,397.321l2.341,1.5c.778.5,1.54,1.249,2.515.991a.994.994,0,0,0,.641-1.212c-.167-.9-1.393-1.373-2.106-1.826l-2.348-1.488a1.151,1.151,0,0,0-1.537.494,1.167,1.167,0,0,0,.494,1.537Z",
    transform: "translate(-1101.437 -395.154)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2802",
    "data-name": "Group 2802",
    transform: "translate(15.152 0.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6860",
    "data-name": "Path 6860",
    d: "M996,265.389c-3.254-6.722-3.2-6.76-3.811-7.294a1,1,0,0,0-1.641.768c.046.849.053.708,3.5,7.768a1.162,1.162,0,0,0,1.6.353,1.183,1.183,0,0,0,.353-1.6Z",
    transform: "translate(-990.544 -257.857)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2803",
    "data-name": "Group 2803",
    transform: "translate(30.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6861",
    "data-name": "Path 6861",
    d: "M1059.618,262.861a17.14,17.14,0,0,0,.763-3.591c.117-1.138.45-2.867-.642-3.592a.85.85,0,0,0-.875.041c-.92.7-.634,2.227-.746,3.276a20.262,20.262,0,0,1-.683,3.382,1.129,1.129,0,0,0,.85,1.333,1.144,1.144,0,0,0,1.334-.85Z",
    transform: "translate(-1057.4 -255.576)",
    fill: "#f8a492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2804",
    "data-name": "Group 2804",
    transform: "translate(43.952 6.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6862",
    "data-name": "Path 6862",
    d: "M1120.921,283.506a.993.993,0,0,0-.74-1.161c-.95-.315-2.118.655-2.872,1.16a19.653,19.653,0,0,0-2.463,1.979,1.138,1.138,0,0,0,.082,1.593,1.157,1.157,0,0,0,1.593-.082C1119.533,284.376,1120.5,284.829,1120.921,283.506Z",
    transform: "translate(-1114.558 -282.283)",
    fill: "#f8a492"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6863",
    "data-name": "Path 6863",
    d: "M1636.795,486.692l-1.992,2.284-3.456-1.246-3.261,3.154-2.937-.461-.87,1.539,3.927.615,3.09-2.989,3.6,1.3,3-3.437Z",
    transform: "translate(-1292.537 -432.353)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6864",
    "data-name": "Path 6864",
    d: "M386.978,430.739c-2.849,3.99-.219,9.79,3.892,11.657a11.085,11.085,0,0,0,13.161-3.493c3.2-4.291,2.41-9.529-1.741-12.2a6.143,6.143,0,0,0-9.585,4.145c-.589,3.188,1.346,5.537,3,5.46a1.411,1.411,0,0,0,.984-2.461,1.384,1.384,0,0,0-1.492-.13c-.812-.966-.782-3.374.977-5.044,2.247-2.133,5.6-.518,6.988,1.787,1.762,2.933.385,6.466-1.986,8.595a9.053,9.053,0,0,1-9.465,1.568,7.054,7.054,0,0,1-3.523-9.223A.688.688,0,0,0,386.978,430.739Z",
    transform: "translate(-341.656 -385.451)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    transform: "translate(0 76.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2806",
    "data-name": "Group 2806",
    transform: "translate(74.991 259.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6865",
    "data-name": "Path 6865",
    d: "M523.628,1698.019s-.5,9.338-.506,9.358c-.192,1.186-.952,4.118-.949,5.2.012,4.048,18.1-3.514,14.037-5.291-.368-.161-2.87-2.295-2.995-3.672-.192-2.122-.1-5.5-.1-5.5Z",
    transform: "translate(-521.362 -1698.019)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6866",
    "data-name": "Path 6866",
    d: "M533.485,1737.366a65.747,65.747,0,0,1-6.425,1.576c-2.177.319-5.056-2.276-6.594-1.565-1.693.782-1.783,9.709-1.783,9.709s22.3,1.6,28-.068C549.244,1746.269,542.186,1740.212,533.485,1737.366Z",
    transform: "translate(-518.682 -1728.142)",
    fill: "#142c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2807",
    "data-name": "Group 2807",
    transform: "translate(109.911 258.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6867",
    "data-name": "Path 6867",
    d: "M674,1697.372s-.5,9.338-.507,9.357c-.192,1.186-.953,4.118-.949,5.2.012,4.048,18.1-3.514,14.037-5.291-.368-.161-2.87-2.295-2.994-3.672-.193-2.122-.1-5.5-.1-5.5Z",
    transform: "translate(-671.731 -1697.372)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6868",
    "data-name": "Path 6868",
    d: "M683.854,1736.717a65.713,65.713,0,0,1-6.425,1.576c-2.177.319-5.056-2.275-6.594-1.565-1.693.783-1.783,9.709-1.783,9.709s22.3,1.6,28-.067C699.612,1745.62,692.555,1739.563,683.854,1736.717Z",
    transform: "translate(-669.051 -1727.493)",
    fill: "#142c1f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6869",
    "data-name": "Path 6869",
    d: "M618.749,596.319c.6,4.557,1.318,4.265,1.38,4.851.072.694-4.1,9.078-4.1,9.078s-12.123,24.792-12.824,26.109l-21.641,18.287,5.662,13.413s23.035-20.527,24.059-21.812,13.622-36.688,14.828-39.77c0,0,2.759-3.154,4.429-5.192s2.376-4.716,2.761-5.362a24.088,24.088,0,0,0,1.937-5.44c.62-2.687-1.168-.409-1.168-.409s-2.021,4.783-2.36,4.56c-.261-.171.992-2.718,1.708-5.685.184-.763.363-1.516.523-2.21.417-1.82-.553-2.585-1.286-.746a19.194,19.194,0,0,0-.845,2.554,15.806,15.806,0,0,1-.929,2.349,20.741,20.741,0,0,1-.972,2.414c-.058-.07-.361.137-.19-.679.206-.98,1.092-2.972,1.286-4.436.109-.83.441-2.552.441-2.552a16.711,16.711,0,0,0-.125-2.744c-.831-.282-1.357,1.558-1.362,2.7a12.866,12.866,0,0,0-.669,2.554s-1.412,3.557-1.9,3.368c-.21-.08.4-2.364.66-4.693.239-2.163.135-4.382-.275-4.489-.7-.181-1.213,2.2-1.213,2.2s-.274,1.683-.407,2.236c-.155.648-.766,2.553-.766,2.553s-2.429,6.538-2.879,6.318-1.38-1.259-1.366-1.715.468-1.285.482-1.741a1.112,1.112,0,0,0-.9-1.109c-.547-.052-1.44,2.139-1.44,2.139A7.672,7.672,0,0,0,618.749,596.319Z",
    transform: "translate(-491.973 -582.332)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6870",
    "data-name": "Path 6870",
    d: "M213.378,642.635c.271,4.587-.493,4.437-.442,5.024.059.695,5.73,8.143,5.73,8.143s16.57,22.06,17.506,23.22L260.865,692.9l-3.036,14.241s-26.484-15.812-27.732-16.881S209.817,656.8,208.052,654c0,0-3.3-2.577-5.326-4.263s-3.221-4.183-3.721-4.745a24.091,24.091,0,0,1-2.925-4.977c-1.115-2.523,1.07-.622,1.07-.622s2.884,4.316,3.176,4.034c.224-.217-1.486-2.483-2.747-5.262-.324-.714-.642-1.42-.928-2.071-.753-1.709.056-2.643,1.122-.976a19.143,19.143,0,0,1,1.31,2.349,15.785,15.785,0,0,0,1.354,2.131,20.832,20.832,0,0,0,1.409,2.188c.044-.08.38.066.059-.7-.386-.924-1.631-2.713-2.1-4.114-.264-.794-.914-2.423-.914-2.423a16.677,16.677,0,0,1-.392-2.718c.763-.433,1.626,1.275,1.846,2.4a12.856,12.856,0,0,1,1.137,2.382s2.056,3.227,2.5,2.948c.191-.118-.84-2.245-1.531-4.484-.642-2.079-.957-4.278-.574-4.461.65-.309,1.6,1.928,1.6,1.928s.586,1.6.82,2.119c.275.607,1.234,2.363,1.234,2.363s3.615,5.962,4.016,5.661a3.231,3.231,0,0,0,1.019-1.942c-.1-.445-.7-1.173-.8-1.619a1.113,1.113,0,0,1,.673-1.259c.527-.154,1.816,1.829,1.816,1.829A7.677,7.677,0,0,1,213.378,642.635Z",
    transform: "translate(-195.763 -619.377)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6871",
    "data-name": "Path 6871",
    d: "M549.486,1179.139s27.635,64.807,28.668,70.653c.753,4.266-.063,52.84-.063,52.84l12.974-.263,4.39-55.5-17.284-69.9Z",
    transform: "translate(-467.341 -1038.871)",
    fill: "#27ba86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6872",
    "data-name": "Path 6872",
    d: "M497.608,1177.29l12.718,72.057-8.029,48.277,14.777-.063,11.45-51.928,1.428-56.855-6.041-18.271Z",
    transform: "translate(-427.511 -1033.914)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6873",
    "data-name": "Path 6873",
    d: "M448.291,830.464s3.285,14.509,5.569,16.764c0,0-11.573,7.755-11.026,10.805s13.025,60.078,13.025,60.078-25.3,13.237-41.062,11.188c0,0-12.059-64.962-15.138-68s-12.624-7.835-12.624-7.835,7.086-13.636,7.079-16.046c0,0,16.937,7.749,19.8,10.577s8.39-.795,9.721-1.362C423.638,846.632,446.262,831.708,448.291,830.464Z",
    transform: "translate(-342.617 -772.841)",
    fill: "#f3fffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6874",
    "data-name": "Path 6874",
    d: "M505.265,846.23l-2.109,13.351s5.657,9.3,10.159,7.887c3.778-1.182,3.43-8.54,3.43-8.54s-2.084-7.6-1.477-11.418S505.265,846.23,505.265,846.23Z",
    transform: "translate(-431.771 -784.312)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6875",
    "data-name": "Path 6875",
    d: "M521.685,847.51c.607-3.813-10-1.28-10-1.28l-.168,1.117a6.162,6.162,0,0,0,1.157,1.871,14.036,14.036,0,0,0,9.3,4.11A20.528,20.528,0,0,1,521.685,847.51Z",
    transform: "translate(-438.188 -784.312)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2808",
    "data-name": "Group 2808",
    transform: "translate(61.652 31.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6876",
    "data-name": "Path 6876",
    d: "M501.862,752.986c-.3-.106-2.36,15.338,1.648,19.567s11.8,5.586,14.578,2.229c3.078-3.714,2.873-20.3-3.352-24.643S501.862,752.986,501.862,752.986Z",
    transform: "translate(-491.819 -741.799)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6877",
    "data-name": "Path 6877",
    d: "M471.622,721.524c-2.179.264-5.98,3.279-9.025,8.3-3.744,6.169,1.007,13.705,5.4,17.031s4.31,7.2,4.31,7.2l.716-2.01a11.047,11.047,0,0,0,.535-4.71,9.108,9.108,0,0,0-.717-2.827c-1.06-2.229,2.252-3.728,3.175-5.59.712-1.434.737-4.708,1.858-7.078l1.342-1.812s3.807.311,6.143-1.741C492.066,722.388,481.772,714.667,471.622,721.524Z",
    transform: "translate(-461.244 -718.833)",
    fill: "#634a1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6878",
    "data-name": "Path 6878",
    d: "M510.824,806c.037,1.883-.825,3.428-1.925,3.452s-2.023-1.484-2.06-3.367.825-3.428,1.925-3.451S510.787,804.118,510.824,806Z",
    transform: "translate(-496.249 -783.173)",
    fill: "#f8a492"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2810",
    "data-name": "Group 2810",
    transform: "translate(229.212 71.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6879",
    "data-name": "Path 6879",
    d: "M1388.093,698.241a14.977,14.977,0,0,0-19.241,3.753,15.551,15.551,0,0,0-12.134,1.325c-7.081,4.087-11.428,15.537-5.687,21.755,1.4,6.4,3.957,11.452,10.32,11.534,3.757,6.907,15.46,8.923,22.228,2.447,5.906,1.867,12.222-1.512,16.325-6.205.968-1.107,1.786-2.85,2.155-3.082.005,0,15.234-2.8,13.852-17.556C1414.463,696.771,1398.418,686.118,1388.093,698.241Z",
    transform: "translate(-1309.92 -662.413)",
    fill: "#142c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6880",
    "data-name": "Path 6880",
    d: "M1239.156,1510.732a86.392,86.392,0,0,0,1.794,13.4c.09.342,1.182,1.695,1.283,2.046-1.649,7.869-7.085,11.945-12.057,14.7,1.484-3.88,4.253-8.19,4.08-9.12a119.1,119.1,0,0,0-3.979-16.86C1234.124,1514.962,1235.771,1512.735,1239.156,1510.732Z",
    transform: "translate(-1219.168 -1290.249)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6881",
    "data-name": "Path 6881",
    d: "M1221.348,1097.525l23.676,19.171s-11.93,11.762-16.405,16.134-26.99,20.124-27.385,21.131a34.684,34.684,0,0,1,1.472,5.6c.988,8.09,2.1,23.823,2.436,37.314-2.548,2.671-8.065,3.3-11.363,4.144-8.111-16.578-11.042-48.4-11-52.221C1182.834,1142.571,1221.348,1097.525,1221.348,1097.525Z",
    transform: "translate(-1182.773 -973)",
    fill: "#2f3e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M1587.265,1241.267c-.929.6-8.22,9.681-11.34,14.731-2.41-2.518-3.631-5.128-6.5-7.118,3.3-3.163,10.1-11.043,10.964-13.1,2.053-4.873,3.323-5.361,3.323-5.361s15.088,9.653,15.824,11.531S1591,1238.877,1587.265,1241.267Z",
    transform: "translate(-1479.63 -1075.034)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6883",
    "data-name": "Path 6883",
    d: "M1613.636,1228.386c-1.269-.3,1.413-5.961,2-7.272.665-1.475,1.627-1.736,1.853-1.741.613-.012,17.38,10.716,19.947,13.75a3.981,3.981,0,0,1,.471.913c.968,3.677-14.145.751-15.988-1.192C1620.285,1231.115,1619.344,1229.722,1613.636,1228.386Z",
    transform: "translate(-1513.319 -1066.551)",
    fill: "#142c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M1326.7,1089.835l22.531-9.545c-.083.038.106.891.133.953,3.351,7.641,11.22,7.408,14.879,19.8,2.893,9.8,1.28,42.6,1.28,42.6s9.753-7.111,19.989-14.7c.933-.692,8.26,7.459,8.26,7.459-13.934,23.349-35.486,32.347-38.215,31.269-9.315-3.681-23.158-66.319-23.134-66.314C1330.623,1097.614,1326.7,1089.835,1326.7,1089.835Z",
    transform: "translate(-1293.273 -959.767)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6885",
    "data-name": "Path 6885",
    d: "M1472.6,817.532s25.633-5.128,31.337-5.92,25.6-7.171,26.369-7.445,3.874-10.659,4.963-9.868-1.857,5.221-.483,5.885,13.387-4.251,13.44-3.249c.1,1.876-7.236,3.3-7.031,4.17s7.513-2.221,8.358-.892-7.193,2.255-7.36,2.971,7.69.174,7.219,1.7c-.255.826-7,.307-6.742,1.3s5.369,2.211,4.985,3.132-4.162-1.614-6.838-1.048-4.917-.454-8.9,1.734-17.1,11.6-26.292,13.217-29.476,5.241-29.476,5.241Z",
    transform: "translate(-1405.295 -740.159)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6886",
    "data-name": "Path 6886",
    d: "M1232.467,635.922s-9.7-24.273-12.156-29.484-7.976-25.364-8.164-26.154,6.813-9.066,5.555-9.547-3.359,4.407-4.665,3.619-3.75-13.536-4.619-13.033c-1.626.94,1.187,7.864.346,8.168s-2.242-7.507-3.818-7.489,2.039,7.257,1.53,7.788-4.346-6.346-5.364-5.121c-.553.666,3.565,6.032,2.6,6.356s-4.784-3.29-5.347-2.466,3.625,2.6,4.613,5.155,3.066,3.871,3.407,8.4-.378,20.665,3.287,29.243,11.709,27.554,11.709,27.554Z",
    transform: "translate(-1194.704 -561.307)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6887",
    "data-name": "Path 6887",
    d: "M1287.242,878.271c-.312-4.507-.8-16.666-.587-18.159-1.258-4.691-5.948-11.672-6.926-13.644,0,0,6.527-7.577,11.311-7.466,0,0,5.025,6.767,8.783,8.862a9.076,9.076,0,0,0,1.893.611c3.649.009,16.4-.271,18.77.494l-1.548,20.569c-.7,1.173-1.759,24.83-3.188,26.764s-22.032,10.6-25.41,8.281C1290.206,904.492,1287.873,887.383,1287.242,878.271Z",
    transform: "translate(-1257.213 -774.513)",
    fill: "#1c9d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6888",
    "data-name": "Path 6888",
    d: "M1427.229,880.421a10.255,10.255,0,0,1,3.878-.6c5.782-.044,15.519-.191,15.519-.191s2.257,12.4.308,15.361c0,0-15.235,2.218-14.815,3.526Z",
    transform: "translate(-1370.459 -805.708)",
    fill: "#1c9d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6889",
    "data-name": "Path 6889",
    d: "M1374.935,834.955s-1.39,7.127-1.153,9.946-1.122,11.883-6.828,11.858-.971-11.551-.407-14.306.775-11.3.775-11.3Z",
    transform: "translate(-1322.043 -768.49)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6890",
    "data-name": "Path 6890",
    d: "M1377.057,835.442c.112-2.336.16-4.285.16-4.285l7.613,3.8s-.284,1.458-.573,3.315A6.546,6.546,0,0,1,1377.057,835.442Z",
    transform: "translate(-1331.939 -768.49)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6891",
    "data-name": "Path 6891",
    d: "M1378.469,759.526a9.8,9.8,0,0,1,3.972,5.453c1.042,3.714-.278,13.26-7.915,15.492s-10.862-5.368-9.236-11.27S1370.4,755.84,1378.469,759.526Z",
    transform: "translate(-1322.589 -712.741)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6892",
    "data-name": "Path 6892",
    d: "M1362.583,784.494c.134,1.591.96,2.813,1.848,2.731s1.5-1.438,1.364-3.029-.961-2.813-1.848-2.731S1362.449,782.9,1362.583,784.494Z",
    transform: "translate(-1320.812 -730.335)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6893",
    "data-name": "Path 6893",
    d: "M1234.218,1568.659c.632-1.188,4.955,3.449,5.991,4.411a2.7,2.7,0,0,1,1.074,2.347c-.158.6-14.364,14.734-18.217,16.434a1.987,1.987,0,0,1-1.276-.042c-1.892-1.068,2.943-13.542,5.872-15.741C1229.555,1574.647,1231.376,1574,1234.218,1568.659Z",
    transform: "translate(-1212.401 -1334.574)",
    fill: "#142c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6894",
    "data-name": "Path 6894",
    d: "M1419.572,760.658s1.277,10.676,4.557,12.632,1.853,6.672,1.853,6.672,3.1-10.954.525-14.507A14.422,14.422,0,0,0,1419.572,760.658Z",
    transform: "translate(-1364.581 -714.363)",
    fill: "#142c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6895",
    "data-name": "Path 6895",
    d: "M1428.44,816.282c-.908,1.38-.921,3.018-.028,3.659s2.352.041,3.26-1.34.921-3.018.028-3.659S1429.348,814.9,1428.44,816.282Z",
    transform: "translate(-1370.86 -755.844)",
    fill: "#f8a492"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionDone);
export default __webpack_public_path__ + "static/media/nutritionDone.588eabf9381af665f8dcb76294104f3b.svg";
export { ForwardRef as ReactComponent };